// extracted by mini-css-extract-plugin
module.exports = {"copyWrapper":"style-module--copyWrapper--26aNr","copySection":"style-module--copySection--1Xzkj"};